import { render, staticRenderFns } from "./NewStatusPopup.vue?vue&type=template&id=0ecd5509"
import script from "./NewStatusPopup.vue?vue&type=script&lang=js"
export * from "./NewStatusPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports